import { render, staticRenderFns } from "./GenderEnrolments.vue?vue&type=template&id=76f49ae2&"
import script from "./GenderEnrolments.vue?vue&type=script&lang=js&"
export * from "./GenderEnrolments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports